var exports = {
  "section": "section__or-mgM",
  "normalizeMargin": "normalizeMargin__1JaGr3",
  "normalizePadding": "normalizePadding__yC_PCQ",
  "sectionIntro": "sectionIntro__1UqhH8",
  "riverBreakoutNoCta": "riverBreakoutNoCta__1GxeHx",
  "paddingBottom-spacious": "paddingBottom-spacious__ETvZJF",
  "paddingBottom-normal": "paddingBottom-normal__SNSmEn",
  "paddingBottom-condensed": "paddingBottom-condensed__dZBXMh",
  "paddingBottom-none": "paddingBottom-none__0jR0u6",
};

__webpack_require__.r(module.exports = exports);
